import {mapActions, mapState} from "vuex";
import {PLAN_NO, PLAN_TYPE} from "@/contants/plan";

export default () => ({
  computed: {
    ...mapState("dashboard", {
      paymentInfo: state => state.paymentInfo
    }),
    notAnnually() {
      if (Object.keys(this.paymentInfo).length <= 0) return

      return this.paymentInfo.type !== PLAN_TYPE.ANNUALLY
    },
  },
  methods: {
    ...mapActions("dashboard", {
      fetchPaymentInfo: "fetchPaymentInfo"
    }),
    planPromotionConditions(yearlyMode, planNo) {
      const planType = yearlyMode ? PLAN_TYPE.ANNUALLY : PLAN_TYPE.MONTHLY
      if (!planNo) return {}
      const applied = this.appliedPromotion(planType, planNo)

      if (!applied?.appliedPromotion) return {}
      if (applied?.appliedPromotion.conditions.length <= 0) return {}

      if (applied?.appliedPromotion.code) {
        return applied
      }

      return {}
    },
    planCouponConditions(yearlyMode, planNo) {
      const planType = yearlyMode ? PLAN_TYPE.ANNUALLY : PLAN_TYPE.MONTHLY
      if (this.isDevelopmentStore && planNo === PLAN_NO.PROFESSIONAL) {
        planNo = PLAN_NO.BUILD;
      }
      if (!planNo) return {}
      const applied = this.appliedPromotion(planType, planNo)

      if (!applied?.appliedCoupon) return {}
      if (applied?.appliedCoupon.conditions.length <= 0) return {}

      if (applied?.appliedCoupon.code) {
        return applied
      }

      return {}
    },
    appliedPromotion(planType, planName) {
      if (this.isDevelopmentStore && planName === PLAN_NO.PROFESSIONAL) {
        planName = PLAN_NO.BUILD;
      }
      if(planName == PLAN_NO.DEVELOPMENT) return 0;
      if (Object.keys(this.paymentInfo).length <= 0) return
      return this.paymentInfo.plans.find((plan) => plan.planType === planType && plan.planName === planName)
    },
    pricingByPlan(planName, planType) {
      if (this.isDevelopmentStore && planName === PLAN_NO.PROFESSIONAL) {
        planName = PLAN_NO.BUILD;
      }
      if(planName == PLAN_NO.DEVELOPMENT) return 0;
      if (Object.keys(this.paymentInfo).length <= 0) return
      return this.paymentInfo.plans.find((plan) => plan.planType === planType && plan.planName === planName)
    },
  }
});
